// REACT
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
// REDUX
import { connect } from "react-redux";
import {
  removeInventoryItem,
  addInvToShopping,
  editInventoryItemSlider,
  editInventoryItem,
  setSelectedItem,
} from "../../Actions/inventoryActions";
import {
  removeTrashItem,
  addTrashToShopping,
} from "../../Actions/trashActions";
import {
  removeShoppingItem,
  checkItem,
  removeAllShoppingItems,
} from "../../Actions/shoppingActions";
import {
  setInventory,
  setTrash,
  setShopping,
} from "../../Actions/mainScreenActions";
import { setFilter, emptyFilter } from "../../Actions/searchActions";
import {
  addFirebaseListeners,
  removeFirebaseListener,
} from "../../Actions/firebaseActions";
// COMPONENTS
import Header from "../Presentation/Header/Header";
import Navigation from "../Presentation/Navigation/Navigation";
import Inventory from "../Presentation/Inventory/Inventory";
import Trash from "../Presentation/Trash/Trash";
import Shopping from "../Presentation/Shopping/Shopping";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "react-bootstrap";
let langData = require("../../Data/language.json");

class MainScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleteAllDialog: false,
      delAllItem: "",
      delAllFrom: "",
    };
  }

  onDelete = (item, from, removeAll, doubleChecked) => {
    if (removeAll && !doubleChecked && from === "inventory") {
      this.handleDeleteAllOpen(item, from);
    } else {
      if (from === "inventory") {
        this.props.removeInventoryItem(this.props.username, item, removeAll);
      } else if (from === "trash") {
        this.props.removeTrashItem(this.props.username, item, removeAll);
      } else if (from === "shopping") {
        this.props.removeShoppingItem(this.props.username, item, removeAll);
      }
      this.setState({ delAllItem: "", delAllFrom: "" });
    }
  };

  componentDidMount() {
    if (this.props.username !== "") {
      this.props.addFirebaseListeners(this.props.username);
    }
    window.addEventListener("touchstart", this.touchStart);
    window.addEventListener("touchmove", this.preventTouch, { passive: false });
  }

  componentWillUnmount() {
    this.props.removeFirebaseListener(this.props.username);
    window.removeEventListener("touchstart", this.touchStart);
    window.removeEventListener("touchmove", this.preventTouch, {
      passive: false,
    });
  }

  touchStart(e) {
    this.firstClientX = e.touches[0].clientX;
    this.firstClientY = e.touches[0].clientY;
  }

  preventTouch(e) {
    const minValue = 5; // threshold
    this.clientX = e.touches[0].clientX - this.firstClientX;
    this.clientY = e.touches[0].clientY - this.firstClientY;
    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(this.clientX) > minValue) {
      e.preventDefault();
      e.returnValue = false;
      return false;
    }
  }

  onAddTo = (item, from) => {
    if (from === "inventory") {
      this.props.addInvToShopping(this.props.username, item);
    } else if (from === "trash") {
      this.props.addTrashToShopping(this.props.username, item);
    }
  };

  onSearchChange = (e) => {
    this.props.setFilter(e.target.value);
  };

  screenChangeHandler = (toScreen) => {
    if (toScreen !== this.props.screenMode) {
      this.props.emptyFilter();
      if (toScreen === "inventory") {
        this.props.setInventory();
      } else if (toScreen === "trash") {
        this.props.setTrash();
      } else if (toScreen === "shopping") {
        this.props.setShopping();
      }
    }
  };

  onRemoveAllShoppingItems = () => {
    this.props.removeAllShoppingItems(this.props.username);
  };

  handleCheckItem = (item) => {
    this.props.checkItem(this.props.username, item);
  };

  onProfileClick = () => {
    this.props.history.push("/ProfileScreen");
  };

  onEditItemSlider = (item, amount) => {
    if (this.props.screenMode === "inventory") {
      this.props.editInventoryItemSlider(this.props.username, item, amount);
    }
  };
  onEditInventoryItem = (item, newItem) => {
    this.props.editInventoryItem(this.props.username, item, newItem);
  };

  onItemScreen = (item) => {
    this.props.setSelectedItem(item);
    this.props.history.push("/ItemScreen/" + item.EANcode);
  };

  handleDeleteAllOpen = (item, from) => {
    this.setState({
      deleteAllDialog: true,
      delAllItem: item,
      delAllFrom: from,
    });
  };

  handleDeleteAllClose = (value) => {
    this.setState({ deleteAllDialog: false });
    if (value === "yes") {
      this.onDelete(this.state.delAllItem, this.state.delAllFrom, true, true);
    }
  };

  render() {
    var currentScreen = this.props.screenMode;
    let navStyle = { display: "block" };

    if (currentScreen === "inventory") {
      currentScreen = (
        <Inventory
          language={this.props.language}
          currentInventory={this.props.inventory}
          onDelete={this.onDelete}
          onAddTo={this.onAddTo}
          onSearch={this.onSearchChange}
          filter={this.props.filter}
          emptyFilter={this.props.emptyFilter}
          onEditItemSlider={this.onEditItemSlider}
          onEditInventoryItem={this.onEditInventoryItem}
          onItemScreen={this.onItemScreen}
        />
      );
    } else if (currentScreen === "trash") {
      currentScreen = (
        <Trash
          language={this.props.language}
          currentTrash={this.props.trash}
          onDelete={this.onDelete}
          onAddTo={this.onAddTo}
          onSearch={this.onSearchChange}
          filter={this.props.filter}
          emptyFilter={this.props.emptyFilter}
        />
      );
    } else {
      currentScreen = (
        <Shopping
          language={this.props.language}
          currentShopping={this.props.shopping}
          onDelete={this.onDelete}
          onRemoveAllShoppingItems={this.onRemoveAllShoppingItems}
          onSearch={this.onSearchChange}
          handleCheck={this.handleCheckItem}
          filter={this.props.filter}
          emptyFilter={this.props.emptyFilter}
        />
      );
    }
    return (
      <div className="MainScreen">
        <Header
          isLoggedIn={true}
          showSettingsIcon={true}
          onProfileClick={this.onProfileClick}
          showStatsBtn={true}
          language={this.props.language}
        />
        <Navigation
          switchScreenTo={this.screenChangeHandler}
          currentScreen={this.props.screenMode}
          visibility={navStyle}
        />
        {currentScreen}
        <Dialog
          onClose={() => this.handleDeleteAllClose("no")}
          aria-labelledby="dialogTitle"
          open={this.state.deleteAllDialog}
        >
          <DialogTitle style={{ textAlign: "center" }} id="dialogTitle">
            {" "}
            {langData[this.props.language].dialogs.deleteAll.deleteAll}
            {this.state.delAllItem.name}?
          </DialogTitle>
          <hr />
          <div className="dialogBtnRow row">
            <div className="container-fluid col-6 dialogBtnContainer">
              <Button
                className="dialogYesBtn"
                onClick={() => this.handleDeleteAllClose("yes")}
              >
                <img
                  src={require("../../Images/Icons/yes.svg")}
                  alt="yesIcon"
                ></img>
              </Button>
              <p className="dialogBtnHelperTxt">
                {langData[this.props.language].dialogs.deleteAll.yes}
              </p>
            </div>
            <div className="container-fluid col-6 dialogBtnContainer">
              <Button
                className="dialogNoBtn"
                onClick={() => this.handleDeleteAllClose("no")}
              >
                <img
                  src={require("../../Images/Icons/No.svg")}
                  alt="noIcon"
                ></img>
              </Button>
              <p className="dialogBtnHelperTxt">
                {langData[this.props.language].dialogs.deleteAll.cancel}
              </p>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  username: state.firebase.username,
  language: state.firebase.language,
  inventory: state.firebase.inventory,
  trash: state.firebase.trash,
  shopping: state.firebase.shopping,
  screenMode: state.mainScreen.mainScreenMode,
  filter: state.firebase.filter,
  listenerActive: state.firebase.listenerActive,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setInventory: () => dispatch(setInventory("inventory")),
    setShopping: () => dispatch(setShopping("shopping")),
    setTrash: () => dispatch(setTrash("trash")),
    setFilter: (filterValue) => dispatch(setFilter(filterValue)),
    checkItem: (uid, item) => dispatch(checkItem(uid, item)),
    emptyFilter: () => dispatch(emptyFilter()),
    editInventoryItem: (uid, item, newItem) =>
      dispatch(editInventoryItem(uid, item, newItem)),
    editInventoryItemSlider: (uid, item, amount) =>
      dispatch(editInventoryItemSlider(uid, item, amount)),
    removeInventoryItem: (uid, item, removeAll) =>
      dispatch(removeInventoryItem(uid, item, removeAll)),
    removeTrashItem: (uid, item, removeAll) =>
      dispatch(removeTrashItem(uid, item, removeAll)),
    removeShoppingItem: (uid, item, removeAll) =>
      dispatch(removeShoppingItem(uid, item, removeAll)),
    addInvToShopping: (uid, item) => dispatch(addInvToShopping(uid, item)),
    addTrashToShopping: (uid, item) => dispatch(addTrashToShopping(uid, item)),
    addFirebaseListeners: (uid) => dispatch(addFirebaseListeners(uid)),
    removeFirebaseListener: (uid) => dispatch(removeFirebaseListener(uid)),
    removeAllShoppingItems: (uid) => dispatch(removeAllShoppingItems(uid)),
    setSelectedItem: (item) => dispatch(setSelectedItem(item)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MainScreen)
);
